/**
 * La espera de una pantalla, con la mascota.
 *
 * La mascota y su secuencia —gira con respiración y se desvanece— viven en
 * `@webbuilder/ui`, porque el editor espera por lo mismo y tiene que decirlo
 * igual: cruzar del panel al editor y encontrarse otro indicador se lee como
 * cambiar de producto.
 * Aquí queda sólo lo que es del panel: cómo se enmarca esa espera en una
 * sección y los nombres con que la conocen sus quince pantallas.
 */
import { LoadingMascot, useLoadingMascot } from '@webbuilder/ui'

export type RecordLoaderState = {
  /** Si la pantalla todavía tiene que pintar el cargador. */
  visible: boolean
  phase: 'loading' | 'settling'
}

/**
 * Cuánto más se queda el cargador, en el vocabulario del panel.
 *
 * Envuelve a `useLoadingMascot` sin añadirle nada: son quince pantallas las que
 * lo llaman por este nombre, y renombrarlas todas para ganar una llamada menos
 * no vale el ruido.
 */
export function useRecordLoader(loading: boolean): RecordLoaderState {
  const state = useLoadingMascot(loading)
  return { visible: state.visible, phase: state.spinning ? 'loading' : 'settling' }
}

/** El contorno que gira, suelto, para las esperas que no ocupan una sección. */
export function SpinningMascot({ spinning, size }: { spinning: boolean; size?: number }) {
  return <LoadingMascot spinning={spinning} {...(size === undefined ? {} : { size })} />
}

export function SectionLoader({ loader, label }: {
  loader: RecordLoaderState
  /** Qué se está trayendo. Para el lector de pantalla. */
  label: string
}) {
  const spinning = loader.phase === 'loading'
  return (
    <div className="dash-section-loading" role="status" aria-busy={spinning}>
      <LoadingMascot spinning={spinning} />
      <span className="dash-sr-only">{label}</span>
    </div>
  )
}
